export const POSSIBLE_SLOTS = [8];
for (let hour = 9; hour <= 19; hour++) {
  POSSIBLE_SLOTS.push(hour);
}
